<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-6">
        <h5 class="modal-title" i18n>Booking Preferences</h5>
      </div>
      <div class="col-sm-6 btn-holder text-right">
        <button (click)="save(form)" type="button" class="btn btn-secondary-info">
          <span class="cs-icon cs-icon-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" class="container-box">
        <div class="row">
          <div class="col-sm-12">
            <p i18n>
              Please specify the booking preferences that you would like to set for this rental. These values will be
              updated for this specific rental only.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">
            <mat-form-field2
              class="mat-block"
              matTooltip="The number of hours required for minimum notice before booking. Allowed values: 0-24, 48, 72, 168."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input
                type="number"
                formControlName="leadtime"
                required
                matInput
                placeholder="Minimum leadtime"
                i18n-placeholder
              />
            </mat-form-field2>
          </div>
          <div class="col-sm-3">
            <mat-form-field2
              class="mat-block"
              matTooltip="The number of days of preparation time required between reservations. Either 0, 1 or 2."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input
                type="number"
                formControlName="turnover"
                required
                matInput
                placeholder="Turnover notice"
                i18n-placeholder
                min="0"
                max="2"
                step="1"
              />
            </mat-form-field2>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">
            <mat-form-field2
              class="mat-block"
              matTooltip="The default minimum nights requirement for reservations."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input
                type="number"
                formControlName="minstay"
                required
                matInput
                placeholder="Minimum nights stay"
                i18n-placeholder
                min="0"
                max="1123"
                step="1"
              />
            </mat-form-field2>
          </div>
          <div class="col-sm-3">
            <mat-form-field2
              class="mat-block"
              matTooltip="The default maximum nights allowed for reservations."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <input
                type="number"
                formControlName="maxstay"
                required
                matInput
                placeholder="Maximum nights stay"
                i18n-placeholder
                min="0"
                max="1124"
                step="1"
              />
            </mat-form-field2>
          </div>
          <div class="col-sm-3 mt-2">
            <mat-checkbox
              matTooltip="Allow guest to create a Request to Book for reservations with length of stay above the max nights stay."
              matTooltipPosition="above"
              i18n-matTooltip
              formControlName="allow_rtb_above_max_nights"
              class="align-input-row-end"
              i18n
            >
              Allow Booking above max nights
            </mat-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">
            <p></p>
            <app-select-search
              [inline]="false"
              placeholder="How far in advance may a guest book?"
              i18n-placeholder
              [ctrl]="form.get('maxleadtime')"
              [items]="maxNoticeDaysOptions"
              bindValue="value"
              bindLabel="name"
              [multiple]="false"
            >
            </app-select-search>
          </div>
          <div class="col-sm-4 mt-4">
            <mat-checkbox
              matTooltip="Allow guests to send a Request to Book for dates beyond the availability window."
              matTooltipPosition="above"
              i18n-matTooltip
              formControlName="allow_rtb_beyond_max_days_notice"
              class="align-input-row-end"
              i18n
            >
              Allow Request to Book beyond availability window
            </mat-checkbox>
          </div>
        </div>
        <div class="form-block" formArrayName="day_of_week_min_nights">
          <h6 i18n>Weekday Min Nights</h6>
          <ng-container
            *ngFor="let week of weekMinNights?.controls; let index = index; let last = last"
            [formGroupName]="index"
          >
            <div class="row">
              <div class="col-sm-3">
                <mat-form-field2 class="mat-block">
                  <mat-select formControlName="day_of_week" placeholder="Day of week" i18n-placeholder required>
                    <mat-option *ngFor="let day of weekdays; let index = index" [value]="index">{{ day }}</mat-option>
                  </mat-select>
                </mat-form-field2>
              </div>
              <div class="col-sm-3">
                <mat-form-field2 class="mat-block">
                  <input
                    type="number"
                    formControlName="min_nights"
                    required
                    matInput
                    placeholder="Min nights"
                    i18n-placeholder
                    step="1"
                  />
                </mat-form-field2>
              </div>
              <div class="col-sm-3 mt-4">
                <a href="javascript:;" class="text-danger" (click)="removeWeekDay(index)">
                  <i class="cs-icon cs-icon-trash"></i>
                </a>
              </div>
            </div>
          </ng-container>
          <div *ngIf="weekMinNights?.length < 7" class="mb-3">
            <a href="javascript:;" (click)="newWeekDayMinNightsGroup()">
              <i class="fas fa-plus"></i> <ng-container i18n>Add New Item</ng-container>
            </a>
          </div>
        </div>

        <div class="form-block" formArrayName="seasonal_min_nights">
          <h6 i18n>Seasonal Min Nights</h6>
          <ng-container
            *ngFor="let seasonal of seasonalMinNights?.controls; let index = index; let last = last"
            [formGroupName]="index"
          >
            <div class="row">
              <div class="col-sm-3">
                <mat-form-field2 class="mat-block">
                  <input
                    matInput
                    [matDatepicker]="startPicker"
                    [max]="seasonal.get('end_date').value"
                    placeholder="From:"
                    i18n-placeholder
                    [required]="true"
                    (focus)="startPicker.open()"
                    formControlName="start_date"
                    tabindex="4"
                    readonly
                  />
                  <i matSuffix (click)="startPicker.open()" class="far fa-calendar-alt"></i>
                  <mat-datepicker #startPicker></mat-datepicker>
                  <mat-error *ngIf="seasonal.get('start_date').hasError('required')">
                    <ng-container i18n>Value is required</ng-container>
                  </mat-error>
                  <mat-error *ngIf="seasonal.get('start_date').hasError('overlap')">
                    <ng-container i18n>Date range is overlapping</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-sm-3">
                <mat-form-field2 class="mat-block">
                  <input
                    matInput
                    [matDatepicker]="endPicker"
                    [min]="getSeasonalMinEndDate | call : seasonal.get('start_date').value"
                    placeholder="Until:"
                    i18n-placeholder
                    [required]="true"
                    (focus)="endPicker.open()"
                    formControlName="end_date"
                    tabindex="5"
                    readonly
                  />
                  <i matSuffix (click)="endPicker.open()" class="far fa-calendar-alt"></i>
                  <mat-datepicker #endPicker></mat-datepicker>
                  <mat-error *ngIf="seasonal.get('end_date').hasError('required')">
                    <ng-container i18n>Value is required</ng-container>
                  </mat-error>
                  <mat-error *ngIf="seasonal.get('end_date').hasError('overlap')">
                    <ng-container i18n>Date range is overlapping</ng-container>
                  </mat-error>
                  <mat-error *ngIf="seasonal.get('end_date').hasError('matDatepickerMin')">
                    <ng-container i18n>Min value is</ng-container>&nbsp;
                    <strong>{{
                      seasonal.get('end_date').getError('matDatepickerMin').min | epoch : 'DD-MMM-YYYY'
                    }}</strong>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-sm-3">
                <mat-form-field2 class="mat-block">
                  <input
                    type="number"
                    formControlName="min_nights"
                    required
                    matInput
                    placeholder="Min nights"
                    i18n-placeholder
                    step="1"
                  />
                </mat-form-field2>
              </div>
              <div class="col-sm-3 mt-4">
                <a href="javascript:;" class="text-danger" (click)="removeSeasonal(index)">
                  <i class="cs-icon cs-icon-trash"></i>
                </a>
              </div>
            </div>
          </ng-container>
          <div *ngIf="seasonalMinNights?.length < 7" class="mb-3">
            <a href="javascript:;" (click)="newSeasonalMinNightsGroup()">
              <i class="fas fa-plus"></i> <ng-container i18n>Add New Item</ng-container>
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
